import { Routes } from "@angular/router";
import {HomeModule} from '../../home/home.module';

export const ALL_ROUTES: Routes = [
  { path: "", loadChildren: () => import("../../home/home.module").then(m => m.HomeModule) },
  
];